import { Component} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AddRegionModalComponent } from 'app/modules/well-header-information/pages/assets/company/add-region-modal/add-region-modal.component';
import { EditCompanyModalComponent } from 'app/modules/well-header-information/pages/assets/company/edit-company-modal/edit-company-modal.component';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { CompanyClass } from 'app/modules/well-header-information/model/assets.model';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  standalone: true,
  styleUrls: ['./company.component.scss']
})
export class CompanyComponent {
  public company: CompanyClass;

  constructor(
    private route: ActivatedRoute,
    private wellHeaderService: WellHeaderInfoService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      let companyId = params.get('companyId');
      this.getCompany(companyId)
    });
  }

  getCompany(companyId: any) {
    this.wellHeaderService.getCompanyById(companyId).subscribe((res) => {
      this.company = {
        operatorId: res.data.id,
        name: res.data.companyShortName,
        longName: res.data.companyLongName,
        remarks: res.data.remarks,
        location: res.data.location,
        region: res.data.country,
        createdDate: res.data.inputDate,
        level: 'company'
      };
    })
  }

  editCompanyModal(companyData: any) {
    const dialogRef = this.dialog.open(EditCompanyModalComponent, {
      data: companyData,
      width: "50%"
    });

    dialogRef.afterClosed().subscribe(isSuccess => {
      if (isSuccess) {
        this.getCompany(companyData.operatorId)
      }
    });
  }

  addRegionModal(companyDetails) {
    const dialogRef = this.dialog.open(AddRegionModalComponent, {
      data: companyDetails.operatorId,
      width: "50%"
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.wellHeaderService.getAssetTree().subscribe()
        this.wellHeaderService.updateParentsNode([this.company.operatorId])
      }
    });
  }

  handleDateFormat(dateString: string, withTime: boolean = false){
    return handleFormatDate(dateString,withTime)
  }
}
